import { render, staticRenderFns } from "./UK.vue?vue&type=template&id=0672c53f&"
import script from "./UK.vue?vue&type=script&lang=js&"
export * from "./UK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0672c53f')) {
      api.createRecord('0672c53f', component.options)
    } else {
      api.reload('0672c53f', component.options)
    }
    module.hot.accept("./UK.vue?vue&type=template&id=0672c53f&", function () {
      api.rerender('0672c53f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/UK.vue"
export default component.exports